import { Header } from "../components/layout/Header";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../translations/LanguageContext";

// Generate rows for the dynamic bg
const bgRows = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    duration: 28 + (i % 7) * 4,        // varies speeds: 28s–52s range
    delay: -(i * 3.7),                  // negative delay staggers start position
    opacity: 0.03 + (i % 4) * 0.01,     // variation in faintness
}));

export function Landing() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const bgLine = t("landing.bgWords").join(" • ") + " • ";

    return (
        <>
            <Header />
            <section className="landing-wrapper">
                <div className="bg-text" aria-hidden="true">
                    {bgRows.map((row) => (
                        <div
                            key={row.id}
                            className="bg-text-row"
                            style={{
                                animationDuration: `${row.duration}s`,
                                animationDelay: `${row.delay}s`,
                                opacity: row.opacity,
                            }}
                        >
                            <span>{bgLine}{bgLine}</span>
                            <span>{bgLine}{bgLine}</span>
                        </div>
                    ))}
                </div>

                <div className="landing-content">
                    <h1>{t("common.brand")}</h1>
                    <p className="bold">{t("landing.description")}</p>
                    <button className="accent-btn" onClick={() => navigate("/analyse")}>
                        <p>{t("landing.cta")}</p>
                        <div className="btn-arrow">&rarr;</div>
                    </button>
                </div>
            </section>
        </>
    );
}
